import {
  BOPIS_ITEM_AVAILABILITY,
  BOPIS_ITEM_AVAILABILITY_STATUS,
} from '../../PickupStoreModal/PickUpStoreModal.constants';
import { capitalizeEveryFirstLetterOfWord } from '../util';

export const NearestStoresHaveDefaultStore = (nearestAvailableStore, userDefaultStore) => {
  const arr = nearestAvailableStore?.filter(
    (store) => userDefaultStore?.basicInfo?.storeName === store?.basicInfo?.storeName
  );
  return arr.length;
};

export const getBopisItemInventoryRes = (
  bopisItemInventory,
  isBopisMultipleStoreEnabled,
  defaultSuggestedStore
) => {
  if (isBopisMultipleStoreEnabled) {
    const defaultStoreId = defaultSuggestedStore && defaultSuggestedStore[0]?.basicInfo?.id;
    const filterInventoryResponse = bopisItemInventory?.inventoryResponse?.filter(
      (store) => store?.storeId === defaultStoreId
    );

    return filterInventoryResponse && filterInventoryResponse[0];
  }
  return (
    bopisItemInventory &&
    bopisItemInventory.inventoryResponse &&
    bopisItemInventory.inventoryResponse[0]
  );
};

export const getBopisInventoryStatus = (
  bopisItemInventory,
  isBopisMultipleStoreEnabled,
  defaultSuggestedStore
) => {
  const bopisItemInventoryRes = getBopisItemInventoryRes(
    bopisItemInventory,
    isBopisMultipleStoreEnabled,
    defaultSuggestedStore
  );

  if (bopisItemInventoryRes?.status === BOPIS_ITEM_AVAILABILITY_STATUS.AVAILABLE) {
    return capitalizeEveryFirstLetterOfWord(BOPIS_ITEM_AVAILABILITY_STATUS.INSTOCK);
  }
  if (bopisItemInventoryRes?.status === BOPIS_ITEM_AVAILABILITY.LIMITED) {
    return BOPIS_ITEM_AVAILABILITY.LIMITED;
  }
  if (bopisItemInventoryRes?.status === BOPIS_ITEM_AVAILABILITY_STATUS.UNAVAILABLE) {
    return BOPIS_ITEM_AVAILABILITY_STATUS.OUTOFSTOCK;
  }
  if (bopisItemInventoryRes?.status === 'Limited Availability' && isBopisMultipleStoreEnabled) {
    return BOPIS_ITEM_AVAILABILITY_STATUS.LIMITEDSTOCK;
  }
  return bopisItemInventoryRes && bopisItemInventoryRes.status;
};

export const getIsMultiStore = (
  isBopisMultipleStoreEnabled,
  isBossMultipleStoreEnabled,
  isPickupSelected
) => {
  if (isBopisMultipleStoreEnabled && isPickupSelected === 'bopis') {
    return isBopisMultipleStoreEnabled;
  }
  if (isBossMultipleStoreEnabled && isPickupSelected === 'boss') {
    return isBossMultipleStoreEnabled;
  }
  return false;
};

export function toSentenceCase(str) {
  return str?.toLowerCase()?.replace(/(^\s*\w|[\\.\\!\\?]\s*\w)/g, (c) => {
    return c.toUpperCase();
  });
}
